"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZERO_INTERACTIONS = void 0;
exports.getCommentInteractions = getCommentInteractions;
exports.applyReactionChange = applyReactionChange;
exports.applyUpvoteChange = applyUpvoteChange;
exports.ZERO_INTERACTIONS = {
    reactionCounts: {},
    myReactionType: null,
    upvoteCount: 0,
    myUpvoted: false,
};
function getCommentInteractions({ reactions, upvotes, viewerId, }) {
    const result = {};
    const ensure = (key) => (result[key] ?? (result[key] = { ...exports.ZERO_INTERACTIONS, reactionCounts: {} }));
    for (const r of reactions) {
        const entry = ensure(r.reactTo);
        entry.reactionCounts[r.reactionType] = (entry.reactionCounts[r.reactionType] ?? 0) + 1;
        if (viewerId && r.from === viewerId)
            entry.myReactionType = r.reactionType;
    }
    for (const u of upvotes) {
        const entry = ensure(u.comment);
        entry.upvoteCount++;
        if (viewerId && u.from === viewerId)
            entry.myUpvoted = true;
    }
    return result;
}
/**
 * Applies a reaction-type change to the pre-mutation interaction state.
 * `from`/`to` are `null` for absent.
 */
function applyReactionChange(pre, change) {
    if (change.from === change.to)
        return pre;
    const reactionCounts = { ...pre.reactionCounts };
    if (change.from) {
        const next = (reactionCounts[change.from] ?? 0) - 1;
        if (next > 0)
            reactionCounts[change.from] = next;
        else
            delete reactionCounts[change.from];
    }
    if (change.to)
        reactionCounts[change.to] = (reactionCounts[change.to] ?? 0) + 1;
    return { ...pre, reactionCounts, myReactionType: change.to };
}
/** Applies an upvote presence change to the pre-mutation interaction state. */
function applyUpvoteChange(pre, myUpvoted) {
    if (pre.myUpvoted === myUpvoted)
        return pre;
    return { ...pre, myUpvoted, upvoteCount: pre.upvoteCount + (myUpvoted ? 1 : -1) };
}
//# sourceMappingURL=comment-interactions.js.map